/**
 * name : Application
 * desc : select
 * at : Created by HW with WebStorm on 2018/7/13 14:30.
 * uri :
 */

import CtSelect from './select';

CtSelect.install = Vue => Vue.component(CtSelect.name, CtSelect);

export default CtSelect;



// WEBPACK FOOTER //
// ./src/views/select/index.js